import axios from "axios";
import { toast } from "react-toastify";

export const CHANGE_LANGUAGE_SUCCESS = 'CHANGE_LANGUAGE_SUCCESS';
export const CHANGE_LANGUAGE_FAILURE = 'CHANGE_LANGUAGE_FAILURE';

export const selectLanguageAction = (selectedLanguage) => {
    return async (dispatch) => {
        try {
            dispatch({ type: CHANGE_LANGUAGE_SUCCESS, payload: selectedLanguage });
        } catch (error) {
            console.error(error);
            dispatch({ type: CHANGE_LANGUAGE_FAILURE, payload: error.message });
        }
    }
};

export const changeLanguagePreferenceAction = (selectedLanguage) => {
    return async (dispatch) => {
        const token = localStorage.getItem("Authorization");

        try {
            dispatch({ type: CHANGE_LANGUAGE_SUCCESS, payload: selectedLanguage });
            localStorage.setItem("language", selectedLanguage.name);

            if (token) {
                // Map language name to API value: "Italian" -> "Italy", "English" -> "English"
                const apiLanguageValue = selectedLanguage.name === "Italian" ? "Italy" : selectedLanguage.name;

                await axios.post(
                    `${process.env.REACT_APP_BASE_URL}/user/change/language/v1`,
                    { language: apiLanguageValue },
                    {
                        headers: {
                            Authorization: token,
                        },
                    }
                );
            }
        } catch (error) {
            const message = error?.response?.data?.message || error.message;
            dispatch({ type: CHANGE_LANGUAGE_FAILURE, payload: message });
            toast.error(message);
        }
    };
};